import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useRealTimeStore } from './stores/realTimeStore';
import { Toast } from './components/common/Toast';

import { DevicesScreen } from './components/screens/DevicesScreen';
import { DeviceDetailScreen } from './components/screens/DeviceDetailScreen';
import { ScriptsScreen } from './components/screens/ScriptsScreen';
import { ScriptEditorScreen } from './components/screens/ScriptEditorScreen';
import { SafetyScreen } from './components/screens/SafetyScreen';
import { SafetySettingsScreen } from './components/screens/SafetySettingsScreen';
import { PairingScreen } from './components/screens/PairingScreen';
import { StatisticsScreen } from './components/screens/StatisticsScreen';
import { SettingsScreen } from './components/screens/SettingsScreen';
import { BottomNavigation } from './components/navigation/BottomNavigation';

function App() {
  const { connect, disconnect } = useRealTimeStore();

  useEffect(() => {
    connect();
    return () => {
      disconnect();
    };
  }, [connect, disconnect]);

  return (
    <>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 pb-20">
          <Routes>
            <Route path="/" element={<Navigate to="/devices" replace />} />
            <Route path="/devices" element={<DevicesScreen />} />
            <Route path="/devices/:deviceId" element={<DeviceDetailScreen />} />
            <Route path="/statistics/:deviceId" element={<StatisticsScreen />} />
            <Route path="/scripts" element={<ScriptsScreen />} />
            <Route path="/scripts/new" element={<ScriptEditorScreen />} />
            <Route path="/scripts/edit/:scriptId" element={<ScriptEditorScreen />} />
            <Route path="/safety" element={<SafetyScreen />} />
            <Route path="/safety/settings" element={<SafetySettingsScreen />} />
            <Route path="/pairing" element={<PairingScreen />} />
            <Route path="/settings" element={<SettingsScreen />} />
          </Routes>
          <BottomNavigation />
        </div>
      </Router>

      <Toast />
    </>
  );
}

export default App;
